module.exports = __webpack_public_path__ + "img/U1F47B.86ff618c.png";